import { Type } from 'typebox';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const MealTypes = {
    bottle: 'bottle',
    breastfeeding: 'breastfeeding',
    food: 'food',
    fooddrop: 'fooddrop',
    unknown: 'unknown'
};
export const MealType = Type.Union([
    Type.Literal(MealTypes.bottle),
    Type.Literal(MealTypes.breastfeeding),
    Type.Literal(MealTypes.food),
    Type.Literal(MealTypes.fooddrop),
    Type.Literal(MealTypes.unknown)
]);
export const MealTypeCodec = createFallbackStringEnumCodec(MealTypes, MealTypes.unknown);
export const FoodAmounts = {
    all: 'all',
    most: 'most',
    some: 'some',
    none: 'none',
    unknown: 'unknown'
};
export const FoodAmount = Type.Union([
    Type.Literal(FoodAmounts.all),
    Type.Literal(FoodAmounts.most),
    Type.Literal(FoodAmounts.some),
    Type.Literal(FoodAmounts.none),
    Type.Literal(FoodAmounts.unknown)
]);
export const FoodAmountCodec = createFallbackStringEnumCodec(FoodAmounts, FoodAmounts.unknown);
export const MealNames = {
    breakfast: 'Breakfast',
    amsnack: 'AM Snack',
    lunch: 'Lunch',
    pmsnack: 'PM Snack',
    latesnack: 'Late Snack',
    dinner: 'Dinner',
    unknown: 'unknown'
};
export const MealName = Type.Union([
    Type.Literal(MealNames.breakfast),
    Type.Literal(MealNames.amsnack),
    Type.Literal(MealNames.lunch),
    Type.Literal(MealNames.pmsnack),
    Type.Literal(MealNames.latesnack),
    Type.Literal(MealNames.dinner),
    Type.Literal(MealNames.unknown)
]);
export const MealNameCodec = createFallbackStringEnumCodec(MealNames, MealNames.unknown);
export const ContentOptions = {
    formula: 'formula',
    breastmilk: 'breastmilk',
    milk: 'milk',
    other: 'other',
    unknown: 'unknown'
};
export const ContentOption = Type.Union([
    Type.Literal(ContentOptions.formula),
    Type.Literal(ContentOptions.breastmilk),
    Type.Literal(ContentOptions.milk),
    Type.Literal(ContentOptions.other),
    Type.Literal(ContentOptions.unknown)
]);
export const ContentOptionCodec = createFallbackStringEnumCodec(ContentOptions, ContentOptions.unknown);
export const FoodEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.food),
        mealType: MealTypeCodec,
        mealName: Type.Optional(MealNameCodec),
        stringAmount: Type.Optional(FoodAmountCodec),
        contents: Type.Optional(ContentOptionCodec),
        foods: Type.Optional(Type.String()),
        numericAmount: Type.Optional(Type.Number()),
        amountOffered: Type.Optional(Type.Number()),
        ord: Type.Optional(Type.Integer()),
        preparedActor: Type.Optional(Type.String({ minLength: 1 }))
    })
]));
